export default "__VITE_ASSET__6151090f__"